export default __webpack_public_path__ + "static/media/music_popup_two.b30368e1.png";